<dashboard-header title="My Community" titleCssIcon="community-icon"></dashboard-header>
<div class="light-theme container-fluid community">
    <div class="row border-top border-bottom py-4 align-items-center">
        <div class="col-12 col-lg-9">
            <h2 class="font-weight-bold">Join Us on Slack</h2>
            <div class="pt-2">Join the Equity is Dynamic Slack workspace to contribute to and learn from our Community
                of
                Practice: leaders innovating around equity just like you are.</div>
        </div>
        <div class="col-12 col-lg-3 pt-3 pt-lg-0">
            <a href="https://eex-portfolio.slack.com/archives/C02KE5XHVEJ" target="_blank" class="btn btn-primary col">Equity is dynamic on slack</a>
            <!-- <button class="btn btn-primary col">Equity is dynamic on slack</button> -->
        </div>
    </div>
    <div class="row border-bottom py-4 align-items-center">
        <div class="col-12 col-lg-9 order-1">
            <h2 class="font-weight-bold">Upcoming events</h2>
        </div>
        <div class="col-12 col-lg-3 pt-3 pt-lg-0 order-3 order-lg-2">
            <a href="#" class="btn btn-primary col">See all events and meetups</a>
        </div>
        <div class="col-12 col-lg-9 py-4 order-2 order-lg-3">
            <div class="row " *ngFor="let upcomingEvent of upcomingEvents; let i=index">
                <div class="col-12">
                    <a class="text-default" target="_blank" href="{{upcomingEvent.mobile_check_in_url}}">
                        <div class="border-bottom event d-flex py-3 align-items-center justify-content-between px-3">
                            <div class="d-flex align-items-center">
                                <svg width="44" height="44" viewBox="0 0 44 44" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M34.8333 7.33301H9.16667C7.14162 7.33301 5.5 8.97463 5.5 10.9997V36.6663C5.5 38.6914 7.14162 40.333 9.16667 40.333H34.8333C36.8584 40.333 38.5 38.6914 38.5 36.6663V10.9997C38.5 8.97463 36.8584 7.33301 34.8333 7.33301Z"
                                        stroke="black" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M5.5 18.333H38.5" stroke="black" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M29.3335 3.66699V11.0003" stroke="black" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M14.6665 3.66699V11.0003" stroke="black" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <div class="px-3">
                                    <div>{{upcomingEvent.event_start | date}}</div>
                                    <div class="pt-2 font-weight-bold">{{upcomingEvent.title}}</div>
                                </div>
                            </div>
                            <svg width="10" height="18" viewBox="0 0 10 18" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 17L9 9L0.999999 1" stroke="black" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>

    <div class="row py-4">
        <div class="col-12 col-lg-9">
            <h2 class="font-weight-bold">Find participants</h2>
        </div>
    </div>

    <div class="row border filters ml-2 mr-2">
        <div class="col-12 col-md-4 search-filter py-3">
            <label class="subtitle">Search by name, company, or keyword</label>
            <div class="pt-3">
                <input type="text" class="form-control" [(ngModel)]="filter.term" />
            </div>
        </div>
        <div
            class="col-12 col-md-4 search-filter py-3 border-md-left border-md-right border-top border-bottom border-md-top-0 border-md-bottom-0">
            <label class="subtitle">Sector</label>
            <div class="pt-3" *ngIf="sectors.length > 0">
                <ng-select [items]="sectors" 
                    bindLabel="name" 
                    bindValue="id"
                    placeholder="Select sector"
                    [multiple]="true"
                    notFoundText="No sectors found"
                    [(ngModel)]="filter.sectorIds">
                </ng-select>
            </div>
        </div>
        <div class="col-12 col-md-4 search-filter py-3">
            <label class="subtitle">Filter by City</label>
            <div class="pt-3">
                <input type="text" class="form-control" [(ngModel)]="filter.city" />
            </div>
        </div>
    </div>

    <div class="row border-bottom py-3 align-items-center justify-content-center">
        <div class="col-auto">
            <button type="button" class="btn btn-primary" (click)="search()">Search</button>
        </div>
    </div>

    <div class="row">
        <div class="col-12 py-5 d-flex flex-column align-items-center justify-content-center"
            *ngIf="!userResults || userResults.length <= 0">
            <svg width="202" height="199" viewBox="0 0 202 199" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M100.951 181.086C146.72 181.086 183.823 144.123 183.823 98.5265C183.823 52.93 146.72 15.9668 100.951 15.9668C55.1821 15.9668 18.0791 52.93 18.0791 98.5265C18.0791 144.123 55.1821 181.086 100.951 181.086Z"
                    fill="#FF92B6" />
                <path d="M2.24749 0.291992H0.292969L2.24749 2.23915V0.291992Z" fill="black" />
                <path d="M201.414 199H202V198.319L201.414 197.832V199Z" fill="black" />
                <path d="M102.515 0H2.24805V0.292074H102.515V0Z" fill="black" />
                <path
                    d="M85.2176 84.8962C94.5993 94.2426 99.8765 106.899 99.8765 120.042V198.903H201.414V197.734L117.076 113.714C107.695 104.368 102.417 91.7113 102.417 78.5679V0.291992H2.24805V2.1418L85.2176 84.8962Z"
                    fill="black" />
                <path d="M0 0V0.292074H0.293179L0 0Z" fill="black" />
                <path
                    d="M111.701 179.042C117.369 188.875 129.975 192.185 139.846 186.538C149.716 180.891 153.039 168.332 147.371 158.499C141.703 148.666 129.096 145.356 119.226 151.003C109.453 156.649 106.032 169.208 111.701 179.042Z"
                    fill="#008CF9" />
                <path
                    d="M54.5317 40.5009C60.1998 50.3341 72.8065 53.6442 82.6768 47.9975C92.5472 42.3507 95.8699 29.7915 90.2017 19.9583C84.5336 10.2225 71.9269 6.815 62.0566 12.4618C52.284 18.1085 48.8635 30.6677 54.5317 40.5009Z"
                    fill="#00B05E" />
            </svg>
            <div class="pt-2">Select a filter or search criteria to see a list of participants</div>
        </div>
        <div class="col-12">
            <div class="row light-theme-alt search-results-wrapper">
                <div class="col-12 col-lg-3 py-3 px-lg-4 search-result text-lg-center"
                    *ngFor="let userResult of userResults; let i=index">
                    <a [routerLink]="getParticipantLink(userResult)">
                        <img class="my-3 profile-img"
                            src="{{userResult.userImageData ? userResult.userImageData : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNgYAAAAAMAASsJTYQAAAAASUVORK5CYII='}}" />
                        <div class="search-result-detail">
                            <div class="subtitle text-default">{{userResult.firstName}} {{userResult.lastName}}</div>
                            <div class="pt-2 text-default">{{userResult.companyRol}},</div>
                            <div class="text-blue">{{userResult.company}}</div>
                            <div class="py-lg-3">
                                <span class="text-blue footnote mr-2"
                                    *ngFor="let sector of userResult.sectors">#{{sector.name}}</span>
                            </div>
                        </div>
                    </a>
                    <div class="pt-2 search-result-actions">
                        <a class="col col-md-12 col-lg btn btn-secondary mr-2 mr-md-0 "
                            href="mailto:{{userResult.emailAddress}}">Email</a>
                        <a class="col col-md-12 col-lg btn btn-primary ml-2 ml-md-0 mt-md-2" target="_blank"
                            href="#">Slack</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>